import { compareSemVersions, isRightVersionGreaterThanLeft } from '@Lib/Version';
import * as ReaderClasses from './Versions';
function ReaderClassForVersion(version) {
    /** Sort readers by newest first */
    const allReaders = Object.values(ReaderClasses).sort((a, b) => {
        return compareSemVersions(a.version(), b.version()) * -1;
    });
    for (const reader of allReaders) {
        if (reader.version() === version) {
            return reader;
        }
        if (isRightVersionGreaterThanLeft(reader.version(), version)) {
            return reader;
        }
    }
    throw Error(`Cannot find reader for version ${version}`);
}
export function CreateReader(version, deviceInterface, identifier, environment) {
    const readerClass = ReaderClassForVersion(version);
    return new readerClass(deviceInterface, identifier, environment);
}
